import React from 'react';
import { withStyles } from '@material-ui/styles';
import { withRouter } from 'react-router-dom';

import { Grid, Typography, Tabs, Tab } from '@material-ui/core';
import PropTypes from 'prop-types';
import styles from './style';

import {
  Subjective,
  Objective,
  AssessmentPlan,
  ICD10,
  CPT
} from './components';
import {
  HomeOutlined,
  DescriptionOutlined,
  InfoOutlined,
  AccountBoxOutlined} from '@material-ui/icons';

const StyledTabs = withStyles({
  indicator: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'white',
    height: 4,
    marginBottom: -10,
    '& > div': {
      maxWidth: 40,
      width: '100%',
      backgroundColor: '#e8e8e8',
      borderRadius: 2
    }
  },
  scroller: {
    overflow: 'visible!important'
  },
  root: {
    overflow: 'visible!important'
  }
})(props => <Tabs {...props} TabIndicatorProps={{ children: <div /> }} />);

const StyledTab = withStyles(theme => ({
  root: {
    textTransform: 'none',
    color: '#606060',
    fontWeight: 600,
    fontSize: 16,
    marginRight: 0,
    background: '#E3E3E3',
    borderRadius: '5px 5px 0 0',
    border: '1px solid #C8C8C8',
    minHeight: 50,
    minWidth: 150,
    [theme.breakpoints.down('sm')]: {
      minWidth: 'auto'
    },
    letterSpacing: 0,
    '&:hover': {
      backgroundColor: '#ececec'
    },
    '&:focus': {
      opacity: 1,
      backgroundColor: '#f9f9f9'
    },
    '&.Mui-selected': {
      backgroundColor: 'white',
      border: 'transparent',
      boxShadow: '-1px -2px 2px rgba(0, 0, 0, 0.04)'
    },
    '& span': {
      flexDirection: 'row',
      '& svg': {
        marginBottom: '0!important',
        transform: 'scale(.8)'
      }
    }
  }
}))(props => <Tab {...props} />);

const Default = props => {
  const { classes } = props;
  function TabContainer(props) {
    return (
      <Typography component="div" className={classes.tabWrap}>
        {props.children}
      </Typography>
    );
  }

  TabContainer.propTypes = {
    children: PropTypes.node.isRequired
  };

  const [value, setValue] = React.useState(0);

  function handleChange(event, newValue) {
    setValue(newValue);
  }

  return (
    <div className={classes.root}>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <StyledTabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            className={classes.tabs}>
            Subjective, Objective, Assessment &amp; Plan, ICD10, CPT
            <StyledTab icon={<HomeOutlined />} label="Subjective" />
            <StyledTab icon={<DescriptionOutlined />} label="Objective" />
            <StyledTab icon={<InfoOutlined />} label="Assessment &amp; Plan" />
            <StyledTab icon={<AccountBoxOutlined />} label="ICD10" />
            <StyledTab icon={<AccountBoxOutlined />} label="CPT" />
          </StyledTabs>
          {value === 0 && (
            <TabContainer>
              <Subjective />
            </TabContainer>
          )}
          {value === 1 && (
            <TabContainer>
              <Objective />
            </TabContainer>
          )}
          {value === 2 && (
            <TabContainer>
              <AssessmentPlan />
            </TabContainer>
          )}
          {value === 3 && (
            <TabContainer>
              <ICD10 />
            </TabContainer>
          )}
          {value === 4 && (
            <TabContainer>
              <CPT />
            </TabContainer>
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default withRouter(withStyles(styles)(Default));
